<template>
  <div>
    <div class="row">
      <div class="col">
        <b-card header-tag="header">
          <h3 slot="header">Student Volunteer Application Stats</h3>
          <h3 v-if="isLoadingStats">Loading...</h3>
          <div v-if="appStatistics.isLoaded" class="card-text">
            <div class="row">
              <div class="col">
                <h4>Starts</h4>
                <h5>{{ appStatistics.started }}</h5>
              </div>
              <div class="col">
                <h4>Completed</h4>
                <h5>{{ appStatistics.completed }}</h5>
              </div>
              <div class="col">
                <h4>Team Leader</h4>
                <h5>{{ appStatistics.teamLeader }}</h5>
              </div>
            </div>
          </div>
        </b-card>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <b-list-group>
          <b-list-group-item>
            <h3>Applications</h3>
          </b-list-group-item>
          <b-list-group-item :to="{ name: 'SearchApps'}">
            Search Applications by User
          </b-list-group-item>
          <b-list-group-item :to="{ name: 'SearchAppsByStatus'}">
            Search Applications by Status
          </b-list-group-item>
        </b-list-group>
      </div>
      <div class="col">
        <b-list-group>
          <b-list-group-item>
            <h3>Jury</h3>
          </b-list-group-item>
          <b-list-group-item :to="{ name: 'JuryAssignments'}">
            Jury Assignments
          </b-list-group-item>
          <b-list-group-item :disabled="true" :to="{ name: 'SearchAppsByStatus'}">
            View Jury Statistics
          </b-list-group-item>
        </b-list-group>
      </div>
      <div class="col">
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'AdminDashboard',
    data () {
      return {}
    },
    computed: {
      ...mapState('admin', ['isLoadingStats', 'appStatistics'])
    },
    created: function () {
      if (!this.$store.state.admin.appStatistics.isLoaded) {
        this.$store.dispatch('admin/getAppStatistics')
      }
    }
  }
</script>

<style scoped>
  .col {
    text-align: center;
  }
  .card {
    margin: 10px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/Dashboard.vue